import $ from 'jquery';
import ModalBaseClass from '../../libs/modal/ModalBaseClass';

/**
 * ホテル詳細モーダル
 */
export default class HotelDetailModalClass extends ModalBaseClass {
  constructor() {
    super('#modal_hotel_detail');
    this.name = 'HotelDetailModalClass';

    this.onClickOpenListener = this.onClickOpen.bind(this);
  }

  onCreate() {
    super.onCreate();
    $('.js-modal_hotel_detail').on('click', this.onClickOpenListener);
  }

  onClickOpen(e) {
    e.preventDefault();
    const _this = $(e.currentTarget);

    const id = _this.attr('data-target');

    $('.content', this.target).css({ display: '' });
    $('.content[data-id=' + id + ']', this.target).css({ display: 'block' });

    this.onOpen();
  }

  onOpenAfter() {
    super.onOpenAfter();
    $(window).trigger('resize');
  }
}
